export default __webpack_public_path__ + "static/media/world.3eca6e63.png";